var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{
    'workspace-dashboard': _vm.$route.path === '/Dashboard',
    'workspace-checkin': _vm.$route.path.startsWith('/CheckinMeeting'),
    'workspace-compact':
      _vm.$route.path === '/Dashboard' ||
      _vm.$route.path === '/TransactionRoomBooking' ||
      _vm.$route.path === '/Facility' ||
      _vm.$route.path === '/Zone' ||
      _vm.$route.path === '/Utility' ||
      _vm.$route.path === '/Location' ||
      _vm.$route.path === '/Roompad' ||
      _vm.$route.path === '/ManageUser' ||
      _vm.$route.path === '/ManageRole' ||
      _vm.$route.path.startsWith('/ManageOrder') ||
      _vm.$route.path === '/ViewSchedule',
    'workspace-list-compact':
      _vm.$route.path === '/TransactionRoomBooking' ||
      _vm.$route.path === '/Facility' ||
      _vm.$route.path === '/Zone' ||
      _vm.$route.path === '/Utility' ||
      _vm.$route.path === '/Location' ||
      _vm.$route.path === '/Roompad' ||
      _vm.$route.path === '/ManageUser' ||
      _vm.$route.path === '/ManageRole' ||
      _vm.$route.path.startsWith('/ManageOrder') ||
      _vm.$route.path === '/ViewSchedule',
  }},[(_vm.showGlobalNavigation)?_c('GlobalNavigation',{attrs:{"updated-at":_vm.pageUpdatedAt},on:{"navigation-toggle":function($event){_vm.navExpanded = $event}}}):_vm._e(),_c('v-content',{class:{
      'with-global-navigation': _vm.showGlobalNavigation,
      'navigation-collapsed': _vm.showGlobalNavigation && !_vm.navExpanded,
    }},[(_vm.$route.path == '/MainMenu')?_c('div',{staticClass:"route-content",attrs:{"id":"grad"}},[_c('router-view',{on:{"data-updated":_vm.onPageDataUpdated}})],1):_c('div',{staticClass:"route-content"},[_c('router-view',{on:{"data-updated":_vm.onPageDataUpdated}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }